import {TimeRange} from "./types";
import {Select, MenuItem} from "@mui/material";
import {FormattedMessage, defineMessages} from "react-intl";

type Props = {
    timeRange: TimeRange;
    setTimeRange: (v: TimeRange) => void;
};

// Typed messages for time ranges
const TIME_RANGE_MESSAGES = defineMessages<TimeRange>({
    today: {id: "call_queue.statistics.time-range.today", defaultMessage: "Today"},
    yesterday: {id: "call_queue.statistics.time-range.yesterday", defaultMessage: "Yesterday"},
    "this-week": {id: "call_queue.statistics.time-range.this-week", defaultMessage: "This week"},
    "previous-week": {id: "call_queue.statistics.time-range.previous-week", defaultMessage: "Previous week"},
    month: {id: "call_queue.statistics.time-range.month", defaultMessage: "Past month"},
});

export default (props: Props) => (
    <Select
        value={props.timeRange}
        margin="dense"
        variant="outlined"
        onChange={(ev) => props.setTimeRange(ev.target.value as TimeRange)}
    >
        {Object.values(TimeRange).map((ev) => (
            <MenuItem key={ev} value={ev}>
                <FormattedMessage {...TIME_RANGE_MESSAGES[ev]} />
            </MenuItem>
        ))}
    </Select>
);
